<!-- <ion-row class="phi-align-items-center">
  <ion-col size>
    <h5 class="ml-10 fw-b">Audit Trail</h5>
  </ion-col>
  <ion-col size="auto">
    <button matButton mat-dialog-close class="dialog_btns close_btn"><ion-icon name="close-outline"></ion-icon></button>
  </ion-col>
</ion-row> -->

<ion-row class="header-row ion-align-items-center">
  <ion-col>
    <h3 class="popup-heading ml-15">Audit Trail</h3>
  </ion-col>
  <ion-col size="auto">
    <button mat-icon-button mat-dialog-close class="close-btn">
      <ion-icon name="close-outline"></ion-icon>
    </button>
  </ion-col>
</ion-row>

<mat-dialog-content class="p-0">
  <ion-grid class="confirmation-body">
    <ion-row>
      <ion-col class="p-10" size-sm="12" size-md="12" size-lg="12" size-xs="12">
        <div class="table-card-box mb-15">
          <div class="table-container">
            <table class="hover mb-15">
              <thead>
                <tr>
                  <ng-container *ngFor="let header of auditHeaders">
                    <th class="fs-14 fs_12ForMobile font_bold cl-black">
                      <div class="p-5 verticle-center justify-content-space-between icon-style">
                        {{ header }}
                      </div>
                    </th>
                  </ng-container>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of auditData">
                  <!-- <td>{{ item?.columnName }}</td>
                  <td>{{ item?.oldValue }}</td>
                  <td>{{ item?.createdAt | date: 'dd-MM-yyyy HH:mm:ss' }}</td>
                  <td>{{  item?.newValue }}</td>
                  <td>
                    {{ item?.firstName | titlecase }}
                    {{ item?.lastName | titlecase }}
                  </td>
                  <td>{{ item?.updatedAt | date: 'dd-MM-yyyy HH:mm:ss' }}</td> -->
                  <td>{{ dwmGenericServiceService.getStatusLabel(item?.columnName) || item?.columnName }}</td>
                  <td>{{ dwmGenericServiceService.getStatusLabel(item?.oldValue) || item?.oldValue }}</td>
                  <td>{{ dwmGenericServiceService.getStatusLabel(item?.createdAt) || item?.createdAt | date: 'dd-MM-yyyy HH:mm:ss' }}</td>
                  <td>{{ dwmGenericServiceService.getStatusLabel(item?.newValue) || item?.newValue }}</td>
                  <td>{{ dwmGenericServiceService.getStatusLabel(item?.firstName) || item?.firstName }} {{ dwmGenericServiceService.getStatusLabel(item?.lastName) || item?.lastName }}</td>
                  <td>{{ dwmGenericServiceService.getStatusLabel(item?.updatedAt) || item?.updatedAt | date: 'dd-MM-yyyy HH:mm:ss' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</mat-dialog-content>
